import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5BA3DA"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <G fillRule="evenodd" clipRule="evenodd" filter="url(#c)">
          <Path
            fill="#EF2929"
            d="m2.837 3.98-2.19-.463 2.217-.438.641-2.295.506 2.276 1.98.46-1.957.46-.564 1.872-.633-1.872Z"
          />
          <Path
            fill="red"
            d="m2.837 3.98-2.19-.463 2.217-.438.641-2.295.506 2.276 1.98.46-1.957.46-.564 1.872-.633-1.872Z"
          />
        </G>
        <Path fill="#FAD615" d="M16 9.6H0v-.8h16v.8ZM16 8H0v-.8h16V8Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
